(function($) {
    $.fn.ngoModal = function(action, options, opt_value) {
        return this.each(function() {
            var $self = $(this);
            if (action === "init" || typeof action === "object") {
                if (typeof action === "object") {
                    options = action;
                }
                if (options == null) {
                    options = {};
                }
                var settings = $.extend({}, options);

                $self.data("modal-options", settings);
                if (settings.show === true) {
                    show($self);
                }

                return $self;
            } else if (action === "set" && options != null) {
                var $this = $(this);
                var settings = $this.data("modal-options");
                settings[options] = opt_value;
                $self.data("modal-options", settings);
                $self.data(options, opt_value);
            } else if (action === "show") {
                var $this = $(this);
                return show($this);
            }

            function modal_init($this) {
                var options = $this.data("modal-options");
                if (options == null) {
                    options = {};
                }
                var title = options.title || $this.data("title");
                var width = options.width || $this.data("width");
                var border = options.border || $this.data("border") || "b--moon-gray";
                var background = options.background || $this.data("background") || "";
                var showHeader =
                    options.showHeader === false ? false : options.showHeader || $this.data("show-header") || true;
                var subContainerClassess = options.subContainerClassess || $this.data("subcontainer-classess") || "";
                var contentClassess = options.contentClassess || $this.data("content-classess") || "";

                var html =
                    '<div class="modal-overlay" style="position: fixed; top: 0px; left: 0px; width: 100%; height: 100%; z-index: 1050; overflow-x: hidden; overflow-y: auto; text-align: center; background: rgba(0, 0, 0, 0.5); cursor: pointer;">';
                html +=
                    '<div class="modal-container" role= "dialog" aria-label="" style= "display: inline-block; text-align: left; top: 0px; max-width: 100%; cursor: default;" >';
                html += '<div class="fixed top-1 left-1 right-1 bottom-1 flex';
                if (options && options.bottom_auto) {
                    html += " bottom-auto-ns";
                }
                html += '" > ';

                html += '<div class="modal-subcontainer ';
                if (subContainerClassess) {
                    html += subContainerClassess;
                } else {
                    html += "center mw bg-white flex flex-column";
                    if (!width) {
                        html += " grow-1";
                    }
                }
                html += '" style="';
                if (width) {
                    html += "width: " + width + ";";
                }
                html += '" > ';
                if (showHeader === true || showHeader === undefined) {
                    html += '<div class="modal-header pa3 flex shrink-0 items-center">';
                    html += '<div class="modal-title grow-1"></div>';
                    html +=
                        '<a class="modal-close no-underline lh-solid ' +
                        (options.closeButtonClass || "blue") +
                        ' no-underline-child-hover" target="_self" href="#/#">';
                    html += '<span class="flex items-center">';
                    html +=
                        '<span class="svg mr1" style="width: 16px; height: 16px;"><div><div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x injected-svg" style="width:16px;height:16px" data-src="/img/icons/x.svg"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></div></div></span>';
                    html += '<span class="no-underline underline-hover">Zamknij</span>';
                    html += "</span>";
                    html += "</a>";
                    html += "</div>";
                }
                if (!contentClassess) {
                    contentClassess = "bt " + border + " " + background + " grow-1 overflow-y-auto";
                }
                html += '<div class="modal-content ' + contentClassess + '">';

                html += "</div>";
                html += "</div>";
                html += "</div>";
                html += "</div >";
                html += "</div >";
                var $html = $(html);
                $html.find(".modal-close").on("click.modal", function(e) {
                    e.preventDefault();
                    $html.addClass("dn");
                });
                $html.find(".modal-title").html(title);
                $html.find(".modal-container").attr("aria-label", title);
                $this.data("modal", $html);
                $html.appendTo("body");
                return $html;
            }

            function show($this) {
                var options = $this.data("modal-options") || {};
                var modal = $this.data("modal");
                if (!modal) {
                    modal = modal_init($this);
                }
                var content_url = options.content_url || $this.data("content_url");

                if (content_url) {
                    var loadByIframe =
                        options.load_by_iframe || typeof $this.data("load-by-iframe") === "boolean"
                            ? $this.data("load-by-iframe")
                            : $this.data("load-by-iframe") === "true";
                    var content = modal.find(".modal-content"); //.clone(true);

                    if (loadByIframe) {
                        content
                            .css("padding", "0px")
                            .css("margin", "0 auto")
                            .css("width", "100%")
                            .css("height", "100%");

                        var iframe = $("<iframe>");

                        iframe.attr("src", content_url);
                        iframe
                            .css("width", "100%")
                            .css("height", "100%")
                            .css("border", "none");

                        content.html(iframe);
                    } else {
                        content.html("<i>Trwa ładowanie...</i>");
                        $.ajax({
                            type: "GET",
                            url: content_url,
                            cache: false,
                            xhrFields: {
                                withCredentials: true
                            },
                            success: function(response) {
                                content.html(response);
                                content.find(".modal-close").on("click.modal", function(e) {
                                    e.preventDefault();
                                    modal.addClass("dn");
                                });
                            },
                            error: function(jqXHR, textStatus, errorThrown) {
                                content.html('<b class="red">Nie można załadować treści</b>');
                            }
                        });
                    }
                } else {
                    $this.detach();

                    var $modalFooter = $this.find(".modal-footer").clone();

                    if ($modalFooter.length) {
                        $this.find(".modal-footer").remove();
                        modal.find(".modal-content").after($modalFooter);
                    }

                    modal.find(".modal-content").append($this);
                    $this.find(".modal-close").on("click.modal", function(e) {
                        e.preventDefault();
                        modal.addClass("dn");
                    });
                }

                modal.removeClass("dn");
                return $this;
            }

            return $self;
        });
    };
})(jQuery);
